import NavBar from "@/components/site/NavBar";
import HeroVSL from "@/components/site/HeroVSL";
import AttorneyBar from "@/components/site/AttorneyBar";
import FearSection from "@/components/site/FearSection";
import FounderStory from "@/components/site/FounderStory";
import GoogleReviews from "@/components/site/GoogleReviews";
import Testimonials from "@/components/site/Testimonials";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";

/**
 * Child Custody landing — VSL variant.
 *
 * The Vturb SmartPlayer takes over the above-the-fold experience. Instead
 * of the standard headline + form hero, this page opens with a compact
 * headline, the video, and a single CTA button anchored to the
 * consultation form near the bottom of the page.
 *
 * `source="Child Custody VSL"` tags every lead so A/B performance vs the
 * standard Child Custody landing is trivially filterable in the admin
 * dashboard, LeadConnector, GA4, and JosNexus.
 */
export default function LandingVSL() {
  return (
    <main data-testid="landing-vsl-page" className="relative bg-paper text-ink">
      <NavBar />
      <HeroVSL videoId="6a59cee0318b789100b72048" />
      <AttorneyBar />
      <FearSection />
      <FounderStory />
      <GoogleReviews />
      <Testimonials />
      <FinalCTA source="Child Custody VSL" />
      <Footer />
    </main>
  );
}
